import { gql } from '@apollo/client'
import NOTIFICATION_FRAGMENT from 'apollo/fragments/NOTIFICATION_FRAGMENT'

// NOTIFICATIONS

export default gql`
  query Notifications {
    notifications(first: 300) {
      nodes {
        ...NOTIFICATION_FRAGMENT
      }
    }
  }
  ${NOTIFICATION_FRAGMENT}
`
